import Immutable from 'immutable';
import { createMigration } from './utils';

/**
 * There are a few older talking head videos that have multiple subscenes within a scene that was a result
 * of using text assets as captions. This migration cleans up those subscenes so that we only have 1 subscene
 * per scene.
 */
export const migrationTo9_182 = createMigration({
    migrateVideo(video) {
        return video.withMutations(map => {
            map.get('slides').forEach((scene, i) => {
                map.setIn(['slides', i], this.migrateScene(scene));
            });
        });
    },
    migrateScene(scene) {
        return scene.withMutations(map => {
            // 1. if it's a talking head scene, check if it has multiple subscenes to see if it needs fixing
            // 2. if it needs fixing, set the subscenes to just contain a single subscene (the first one)
            const isVoiceDriven = ['talking_head', 'talking_head_insert', 'voiceover'].find(sceneCategory => sceneCategory === map.get('sceneCategory'));
            if (!isVoiceDriven || map.get('subslides').size <= 1) {
                return;
            }
            let firstSubslide = map.get('subslides').get(0);

            // legacy talking head subscenes have 1 child: empty AssetGroup, so anything other than that we should not accept
            // the migration.
            let subslidesHasUnexpectedChildren = false;
            map.get('subslides').forEach(subslide => {
                if (subslide.get('children').size > 1) {
                    subslidesHasUnexpectedChildren = true;
                }
                else if (subslide.get('children').size === 1) {
                    if (subslide.get('children').get(0).get('classType') !== 'AssetGroup') {
                        subslidesHasUnexpectedChildren = true;
                    }
                }
            });
            if (subslidesHasUnexpectedChildren) {
                throw new Error(`Failed to migrate. Scene ${map.get('id')} has unexpected children`);
            }

            // remove the AssetGroup from the subscene's children as well
            firstSubslide = firstSubslide.set('children', Immutable.fromJS([]));
            // finally set the subscenes in the scene to only contain 1 subscene
            map.set('subslides', Immutable.fromJS([firstSubslide]));
        });
    },
});
